<template>
  <ul class="TheNavbarLinks">
    <li class="TheNavbarLinks__item" v-for="link in links" :key="link.label">
      <UIDropdown
        v-if="link.items"
        :items="[]"
        :offset="[-40, 20]"
        dropdownTheme="topbar"
        placement="auto-start"
        :maxWidth="'unset'"
      >
        <div class="TheNavbarLinks__link">
          {{ link.label }}
        </div>

        <template #content="{ hide }">
          <TheNavbarMenuDropdown :links="link.items" @close="hide()" />
        </template>
      </UIDropdown>

      <RouterLink
        v-else-if="link.link"
        :to="link.link"
        class="TheNavbarLinks__link TheNavbarLinks__link--no-dropdown"
      >
        {{ link.label }}
      </RouterLink>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { RouterLink } from 'vue-router'
import UIDropdown from '../../../dropdowns/UIDropdown.vue'
import { INavbarItem } from '../TheNavbar.vue'
import TheNavbarMenuDropdown from './TheNavbarMenuDropdown.vue'

defineProps<{
  links: INavbarItem[]
}>()
</script>

<style lang="scss" scoped>
.TheNavbarLinks {
  display: flex;
  gap: 0.125rem;
  list-style: none;

  .TheNavbarLinks__link {
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.125rem 0.375rem;
    padding: 4px;
    border-radius: 0.5rem;
    color: $color-ui-gray-cool-700;
    font-weight: 600;

    &:hover {
      color: $color-ui-gray-cool-800;
    }
  }

  .TheNavbarLinks__link--no-dropdown {
    margin-right: 0.75rem;
    text-decoration: none;
  }
}
</style>
